var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { OfferButtonBuy } from "./OfferButtonBuy";
import { OfferRewards } from "./OfferRewards";
export var OfferDetails = function (props) {
    var shopPackage = props.shopPackage, onBuyClick = props.onBuyClick;
    return (React.createElement("div", { className: "offer-body__details" },
        React.createElement(OfferRewards, __assign({}, props)),
        React.createElement("div", { className: "offer-body__buy-btn" },
            React.createElement(OfferButtonBuy, { shopPackage: shopPackage, onClick: function () { return onBuyClick(props); } }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/components/OfferDetails.tsx
// module id = 2912
// module chunks = 3